import { type ComponentOverrides } from "theme/theme.types";

import { BODY_LINE_HEIGHT, TYPE_SCALE } from "theme/typography";

import { colors } from "design-tokens";

/**
 * MUI's `TableCell` is opinionated where the legacy table inherited the document type. Themed
 * rather than fixed per call site: `ui/table` and `ui/data-grid` both render these primitives.
 */
export const MuiTableCell: ComponentOverrides["MuiTableCell"] = {
  styleOverrides: {
    root: {
      fontSize: TYPE_SCALE.md.fontSize,
      lineHeight: BODY_LINE_HEIGHT,
      color: colors.neutrals[900],
      // `body2` pins weight 400, breaking the inheritance `table-group-row` relies on.
      fontWeight: "inherit",
    },
    // Tailwind's preflight does not reset `th`, so the legacy header kept the browser's bold.
    head: {
      fontWeight: 700,
    },
  },
};
